const ResumeGroupDetailPage = () => (
  <section className="my-resume-group"></section>
);

export default ResumeGroupDetailPage;
